// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd","breadcrumbsLink":"Breadcrumbs_breadcrumbsLink__GvykK","homeRun":"Breadcrumbs_homeRun__foZfi","dot":"Breadcrumbs_dot__p99OH"};